import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import deleteAccount from "./buuserdashboard/delete";
import fetchbusinessusers from "../redux/buuserdashboard/registeredusers";
import labTestsReducer from "./apis/lab";
import userListReducer from "./apis/normalUser/userListSlice";
import onlineStatusReducer from "./apis/Businessuser/onlinestatus";
// Reducers
import businessPasswordResetReducer from "./slices/passwords/businessForgotPasswordSlice";
import resetPasswordReducer from "./slices/passwords/resetPasswordRequest";
import Searchcomponentbuser from "./commonsharing/Searchcomponentbuser";
import busercatwise from "./commonsharing/busercatwise";
import authReducer from "./slices/authSlice";
import categoryReducer from "./slices/categorySlice";
import businessReducer from "./slices/businessSlice";
import phonepeReducer from "./phonepay/phonepePaymentSlice";
import bookedUsersReducer from "./slices/bookedUsersSlice";
import appointmentReducer from "./slices/appointmentsSlice"; // 👈
import forgotPasswordReducer from "./slices/passwords/forgotPasswordSlice";
import userReducer from "./slices/userprofileupdate/userprofileupdate";
import businessUserprifileupateReducer from "./slices/businessuserprofileupdate/businessuserprofileupdateslice"; // ✅ NEW
import prescriptionReducer from "./buuserdashboard/doctorprescription";
import usersReducer  from "./maindashboard/dashboardSlice";
//import businessUsers from '../redux/buuserdashboard/businessUserSlice.jslogin';
import { combineReducers } from "redux";
//import { deleteAccount } from './buuserdashboard/delete';
import businessUserProfile from "./apis/Businessuser/businessUserProfile"; // <-- adjust path
import notificationReducer from "./slices/notificationSlice";
import locationReducer from "./commonsharing/locationThunk";
import planReducerlist from "../redux/apis/plansSlice";
// import availabilityReducer from "./slices/availabilitySlice.js/other-medical/availability";
// import otherMedicalAvailabilityReducer from "./apis/Availability/otherMedicalAvailabilitySlice";
// import doctorAvailabilityReducer from "./apis/Availability/otherMedicalAvailabilitySlice";
import doctorReducer from "../redux/apis/Availability/doctorAvailabilitySlice";
import alternativeReducer from "./slices/availabilitySlice.js/alternativeAvailabilitySlice";
import otherReducer from "./slices/availabilitySlice.js/otherMedicalAvailabilitySlice";
const rootReducer = combineReducers({
  auth: authReducer,
  category: categoryReducer,
  selectedBusiness: businessReducer,
  businessUser: businessUserprifileupateReducer, // ✅ REGISTERED
  notification: notificationReducer,
  bookedUsers: bookedUsersReducer,
  appointmentsfromreduxstore: appointmentReducer, // 👈
  forgotPassword: forgotPasswordReducer,
  resetPassword: resetPasswordReducer, // ✅ this must exist
  user: userReducer, // ✅ Must match what you're using in useSelector
  businessForgotPassword: businessPasswordResetReducer,
  prescriptions: prescriptionReducer, // Add the prescription reducer
  businessUserSearch: Searchcomponentbuser,
  businessUserCat: busercatwise,
 users: usersReducer,
  // users: usersReducer,
  users: fetchbusinessusers,
  delete: deleteAccount,
  labTests: labTestsReducer,
  businessUserProfile: businessUserProfile, // 👈 'user' key used in useSelector
  location: locationReducer,
  //  notification: notificationReducer,
  // notifications: notificationReducer,
  userList: userListReducer,
  plans: planReducerlist,
  doctorAvailability: doctorReducer,
  alternativeAvailability: alternativeReducer,
  otherMedicalAvailability: otherReducer,
  phonepe: phonepeReducer,
  

    // IMPORTANT
    businessOnlineStatus:
      onlineStatusReducer,

    // other reducers...
  
});


// persist config
const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Store configuration
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Needed for redux-persist compatibility
    }),
});

export const persistor = persistStore(store);
